/*eslint max-lines-per-function: ["error", 260]*/
import React, { useCallback, useEffect } from 'react';
import { Card, Tab } from 'react-bootstrap';

import { useCookies } from '../../../common/hooks/useCookies';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { ExamSearch } from '../../components/Exam/ExamSearch';
import { TabsHistory } from '../../../app/components/TabsHistory';
import { ArticleMode } from '../../../common/spdCore/validation/schemas';

import { ExamsActiveView } from './ExamsActiveView';

interface ExamsSpecialistProps {
  mode: string;
  articleMode: ArticleMode;
  tabReadyTitle: string;
  tabAllTitle: string;
  onClick: (id: string) => void;
}

export const ExamsSpecialistView: React.FC<ExamsSpecialistProps> = props => {
  const spd = useSpdCore();
  const cookies = useCookies();

  useEffect(() => {
    if (cookies.activeMonitor !== props.mode) {
      cookies.setActiveMonitor(props.mode);
    }
  }, [cookies, props.mode]);

  const handleClick = async (id: string) => {
    props.onClick(id);
  };

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  const handleSelect = (key: any) => {
    cookies.setActiveTabMonitor(key as string);
  };

  const getDataForSpecialist = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) =>
      spd.exams.getForSpecialistByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
        props.articleMode,
      ),
    [spd.exams, props.articleMode],
  );

  const getDataActive = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
    ) =>
      spd.exams.getActiveByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        props.articleMode,
      ),
    [spd.exams, props.articleMode],
  );

  // const getDataWithExamined = useCallback(
  //   (
  //     pageSize: number,
  //     pageNumber: number,
  //     orderBy?: string,
  //     orderDirection?: string,
  //     filterText?: string,

  //     filterColumns?: string,
  //   ) =>
  //     spd.exams.getWithExaminedByPortion(
  //       pageSize,
  //       pageNumber,
  //       orderBy,
  //       orderDirection,
  //       filterText,
  //       filterColumns,
  //       props.articleMode,
  //     ),
  //   [spd.exams, props.articleMode],
  // );

  const getDataAll = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) =>
      spd.exams.getAllByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
        props.articleMode,
      ),
    [spd.exams, props.articleMode],
  );

  const getCountForSpecialist = useCallback(
    (filterText?: string, filterColumn?: string, additionalId?: string) =>
      spd.exams.getForSpecialistCount(
        filterText,
        filterColumn,
        additionalId,
        props.articleMode,
      ),
    [spd.exams, props.articleMode],
  );

  const getCountActive = useCallback(
    (filterText?: string, filterColumn?: string, additionalId?: string) =>
      spd.exams.getActiveCount(
        filterText,
        filterColumn,
        additionalId,
        props.articleMode,
      ),
    [spd.exams, props.articleMode],
  );

  // const getCountWithExamined = useCallback(
  //   (filterText?: string, filterColumns?: string, additionalId?: string) =>
  //     spd.exams.getWithExaminedCount(
  //       filterText,
  //       filterColumns,
  //       additionalId,
  //       props.articleMode,
  //     ),
  //   [spd.exams, props.articleMode],
  // );

  const getCountAll = useCallback(
    (filterText?: string, filterColumns?: string, additionalId?: string) =>
      spd.exams.getAllCount(
        filterText,
        filterColumns,
        additionalId,
        props.articleMode,
      ),
    [spd.exams, props.articleMode],
  );

  const getDataBlocked = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) =>
      spd.exams.getBlockedByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
        props.articleMode,
      ),
    [spd.exams, props.articleMode],
  );

  const getCountBlocked = useCallback(
    (filterText?: string, filterColumns?: string) =>
      spd.exams.getBlockedCount(filterText, filterColumns, props.articleMode),
    [spd.exams, props.articleMode],
  );

  return (
    <Card>
      <TabsHistory
        activeKey={
          cookies.activeTabMonitor ? cookies.activeTabMonitor : 'activeExams'
        }
        id="exams"
        className="mb-3"
        onAdditionalSelect={handleSelect}
      >
        <Tab
          eventKey="withoutJudgmentExams"
          title={props.tabReadyTitle}
          className="m-3"
        >
          <ExamSearch
            getData={getDataForSpecialist}
            getCount={getCountForSpecialist}
            onRowClick={handleClick}
            initialOrderColumn="exams.endDate"
            initialOrderDirection="ASC"
            withFilterInColumns={true}
          />
        </Tab>
        <Tab eventKey="activeExams" title="aktywne" className="m-3">
          <ExamsActiveView
            getData={getDataActive}
            getCount={getCountActive}
            onRowClick={handleClick}
          />
        </Tab>
        {/* <Tab eventKey="examsWithExamined" title="z badanym" className="m-3">
          <ExamSearch
            getData={getDataWithExamined}
            getCount={getCountWithExamined}
            onRowClick={handleClick}
            withFilterInColumns={true}
          />
        </Tab> */}
        <Tab eventKey="blockedExams" title="Zablokowane" className="m-3">
          <ExamSearch
            getData={getDataBlocked}
            getCount={getCountBlocked}
            onRowClick={handleClick}
            withFilterInColumns={true}
          />
        </Tab>
        <Tab eventKey="exams" title={props.tabAllTitle} className="m-3">
          <ExamSearch
            getData={getDataAll}
            getCount={getCountAll}
            onRowClick={handleClick}
            withFilterInColumns={true}
          />
        </Tab>
      </TabsHistory>
    </Card>
  );
};
